import { all } from 'redux-saga/effects';
import login from './login';

export const authenticationSaga = function* root() {
  yield all([login()]);
};

